<app-modal modalTitle="Bijlage toevoegen">
	<div class="modal-body p-4">
			
			<div class="alert alert-info">Selecteer type van het bestand</div>

			<mat-form-field>
				<mat-select [formControl]="attachmentType">
					<mat-option *ngFor="let attachmentType of attachmentTypes" [value]="attachmentType">
						{{ attachmentType.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
	</div>

	<div class="modal-footer">
		<button class="btn md btn-alt" type="button" (click)="activeModal.close(false)">
			Annuleren
		</button>

		<button class="btn md btn-save" type="button" [disabled]="attachmentType.invalid" (click)="activeModal.close(true)">
			Opslaan
		</button>
	</div>
</app-modal>